<template>
  <div class="search">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" :inline="true" class="ruleForm">
      <el-form-item label="起始地" prop="custStartPlace">
        <el-cascader
          placeholder="请选择目的地"
          v-model="ruleForm.custStartPlace"
          :options="countryList"
           clearable
          filterable
          :props="{
          label:'addressName',
          value:'addressCode',
          children: 'child',
          checkStrictly: true
        }"
        
          >
        </el-cascader>
      </el-form-item>
      <el-form-item label="目的地" prop="custEndPlace">
        <el-cascader
          placeholder="请选择目的地"
          v-model="ruleForm.custEndPlace"
          :options="countryList"
           clearable
          filterable
          :props="{
          label:'addressName',
          value:'addressCode',
          children: 'child',
          checkStrictly: true
        }"
        
          >
        </el-cascader>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" @click="submitForm('ruleForm')">运价查询</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "Search",
  props: {
    title: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: "../assets/img/bgtop.jpg"
    }
  },
   data() {
      return {
        countryList:[],
        ruleForm: {
          custStartPlace: [],
          custEndPlace: [],
        },
        propsOptions: {
          label:'addressName',
          value:'addressCode',
          children: 'child',
          expandTrigger: 'hover'
        },
        rules: {
          // custStartPlace: [
          //   { required: true, message: '请选择起始地', trigger: 'change' }
          // ],
          //  custEndPlace: [
          //   { required: true, message: '请选择目的地', trigger: 'change' }
          // ],
        }
      };
    },
    mounted () {
      this.$http
      .all([
        this.$http.get("/system/dictionary/get-country"),
      ])
      .then(
        this.$http.spread((res) => {
          this.countryList = res.data.data;
        })
      );
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$router.push({
              name:'casedetails',
              query:{
                custStartPlace:this.ruleForm.custStartPlace.join(';'),
                custEndPlace:  this.ruleForm.custEndPlace.join(';'),
              }
            })
  
          } else {
            return false;
          }
        });
      },
    },
    
};
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  .el-cascader {
    width: 350px;
  }
  width: 80%;
  margin: 0 auto;
}
.ruleForm {
  width: 80%;
  background: #fff;
  height: 120px;
  border-radius: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>